// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"f3-z"};